import { BaseResponse } from '../manager/handle_data/HandleData';
import { PaginationResponse } from '../types';
import apiService from './api.service';

export interface Option {
  id: number;
  content: string;
  quizId?: number;
  correct: boolean;
}

export interface Game {
  id: string;
  content: string;
  description: string;
  answers: Option[];
  status?: string;
}

export interface GamesResponse {
  pageInfo: PaginationResponse;
  data: Game[];
}

class GameService {
  getAllGames(page = 1, limit = 10): Promise<BaseResponse<Game[]>> {
    return apiService.get('/b/quiz-games', { params: { pageSize: limit, pageNo: page, sort: 'createdAt:desc' } }).then((response) => response.data.data);
  }

  getGameById(id: string): Promise<Game> {
    return apiService.get(`b/quiz-games/${id}`).then((response) => response.data?.data);
  }

  createGame(game: Partial<Omit<Game, 'id'>>): Promise<Game> {
    return apiService.post('b/quiz-games', game).then((response) => response.data);
  }

  updateGame(id: string, game: Partial<Game>): Promise<Game> {
    return apiService.put(`b/quiz-games/${id}`, game).then((response) => response.data);
  }

  deleteGame(id: string): Promise<Game> {
    return apiService.delete(`b/quiz-games/${id}`).then((response) => response.data);
  }

  updateGameStatus(id: string): Promise<{}> {
    return apiService.put(`b/quiz-games/${id}/status`).then((response) => response.data);
  }
}

const gameService = new GameService();
export default gameService;
